import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param payload
 */
class UnicommerceIntegrationServices {
    /**
     * @param orgId
     * @param {*} payload
     * @return
     */
    getUnicommerceConnections = async (orgId) => {
      let url = `${Constants.GET_UNICOMMERCE_CONNECTIONS}`;
      if (orgId) url += `?org_id=${orgId}&`;
      const getUnicommerceConnections = await Helpers.get({
        url,
      });
      return getUnicommerceConnections;
    }

    /**
     *
     * @param orgId
     * @return
     */
    connectToUnicommerce = async (payload) => {
      const url = `${Constants.CONNECT_TO_UNICOMMERCE}`;
      const connectToUnicommerce = await Helpers.post({
        url,
        data: payload,
      });
      return connectToUnicommerce;
    }

    /**
     *
     * @param {*} payload
     * @returns
     */
    connectTenantToLocation = async (payload) => {
      const url = `${Constants.CONNECT_TENANT_TO_LOCATION_UNICOMMERCE}`;
      const connectTenantToLocationData = await Helpers.put({
        url,
        data: payload,
      });
      return connectTenantToLocationData;
    }

    /**
     *
     * @param {*} payload
     * @returns
     */
    syncProducts = async (payload) => {
      const url = `${Constants.SYNC_PRODUCT}`;
      const syncProducts = await Helpers.post({
        url,
        data: payload,
      });
      return syncProducts;
    }

    /**
     *
     * @param {*} payload
     * @returns
     */
    syncSO = async (payload) => {
      const url = `${Constants.SYNC_SO}`;
      const syncSO = await Helpers.post({
        url,
        data: payload,
      });
      return syncSO;
    }

    /**
     * @param orgId
     * @param {*} payload
     * @return
     */
    verifyLocation = async (orgId, facilityCode) => {
      let url = `${Constants.VERIFY_LOCATION}`;
      if (orgId) url += `?org_id=${orgId}&`;
      if (facilityCode) url += `facility_code=${facilityCode}&`;

      const verifyLocation = await Helpers.get({
        url,
      });
      return verifyLocation;
    }

    /**
     *
     * @param {*} payload
     * @returns
     */
       adjustUnicommerceInventory = async (payload) => {
         const url = `${Constants.ADJUST_UNICOMMERECE_INVENTORY}`;
         const adjustUnicommerceInventory = await Helpers.post({
           url,
           data: payload,
         });
         return adjustUnicommerceInventory;
       }

       /**
     *
     * @param {*} payload
     * @returns
     */
      updateUnicommerceConfiguration = async (payload) => {
        const url = `${Constants.UPDATE_UNICOMMERCE_CONFIGURATION}`;
        const updateUnicommerceConfiguration = await Helpers.put({
          url,
          data: payload,
        });
        return updateUnicommerceConfiguration;
      }

      scheduleUcSync = async (payload) => {
        const url = `${Constants.SCHEDULE_UNICOMMERCE_SYNC}`;
        const scheduleUcJob = await Helpers.post({
          url,
          data: payload,
        });
        return scheduleUcJob;
      }

      deleteUcJob = async (payload) => {
        const url = `${Constants.SCHEDULE_UNICOMMERCE_SYNC}`;
        const deletedJob = await Helpers.delete({
          url,
          data: payload,
        });
        return deletedJob;
      }

}
export default new UnicommerceIntegrationServices();
